import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Textarea = React.forwardRef(function Textarea2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      ref,
      className: cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-xs placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 focus-ring",
        className
      ),
      ...props
    }
  );
});

export { Textarea };
//# sourceMappingURL=chunk-V4MOACUU.js.map
//# sourceMappingURL=chunk-V4MOACUU.js.map